var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChecks(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.6665 8.28353L7.99984 11.6169L14.6665 4.9502",
    stroke: "#28C76F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.86383 7.7532C1.57093 7.46031 1.09606 7.46031 0.803166 7.7532C0.510273 8.04609 0.510273 8.52097 0.803166 8.81386L1.86383 7.7532ZM4.1365 12.1472C4.42939 12.4401 4.90427 12.4401 5.19716 12.1472C5.49005 11.8543 5.49005 11.3794 5.19716 11.0865L4.1365 12.1472ZM7.46983 7.7532C7.17694 8.04609 7.17694 8.52097 7.46983 8.81386C7.76273 9.10675 8.2376 9.10675 8.53049 8.81386L7.46983 7.7532ZM11.8638 5.48053C12.1567 5.18763 12.1567 4.71276 11.8638 4.41987C11.5709 4.12697 11.0961 4.12697 10.8032 4.41987L11.8638 5.48053ZM0.803166 8.81386L4.1365 12.1472L5.19716 11.0865L1.86383 7.7532L0.803166 8.81386ZM8.53049 8.81386L11.8638 5.48053L10.8032 4.41987L7.46983 7.7532L8.53049 8.81386Z",
    fill: "#28C76F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChecks);
export default __webpack_public_path__ + "static/media/checks.f2573d32f9646e4fcfd7a7d2692d1fb4.svg";
export { ForwardRef as ReactComponent };